import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { Phone, MessageSquare, Send } from "lucide-react";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./Contact.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");

  const [service, setService] = useState("");
  const [brand, setBrand] = useState("");
const [email, setEmail] = useState("");
const [issue, setIssue] = useState("");

 const handleSubmit = async (e) => {
  e.preventDefault();

  const data = {
    name,
    phone,
    address,
    email,
    brand,
    service,
    issue,
    description,
  };

  try {
    const res = await fetch("https://api.customersupports24x7.in/api/rfq", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    await res.json();
    alert("RFQ Saved ✅");

  } catch (err) {
    console.log(err);
    alert("Error ❌");
  }
};

 
  return (
    <>
      <Helmet>
        <title>Contact Customersupports24x7 | Bangalore</title>
        <meta
          name="description"
          content="Reach Customersupports24x7 for quick appliance repair services in Bangalore. Call now for doorstep assistance."
        />
        <meta
          name="keywords"
          content="contact appliance repair bangalore, repair support bangalore"
        />
        <meta property="og:title" content="Contact Customersupports24x7 | Bangalore" />
        <meta
          property="og:description"
          content="Reach Customersupports24x7 for quick appliance repair services in Bangalore. Call now for doorstep assistance."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/contact" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Customersupports24x7 | Bangalore" />
        <meta
          name="twitter:description"
          content="Reach Customersupports24x7 for quick appliance repair services in Bangalore. Call now for doorstep assistance."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/contact" />
      </Helmet>
      <InnerBanner title="Contact Us" bgImage={serviceBg} />


      <div className="contact-wrapper">
        <div className="contact-grid">

          {/* LEFT */}
          <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }}>
            <div className="status-pill">
              <span className="pulse-dot"></span>
              Technicians Available
            </div>

            <h1 className="hero-text" style={{color: "#333" }}>
              Appliance Repair Service Near You –
              <span className="service-accent"> Expert Technicians</span>
            </h1>

            <p className="hero-description">
              Repair services for Washing Machines, Refrigerators, AC & more.
              Fast doorstep support with genuine spare parts.
            </p>

            <div className="method-stack">
              <a href="tel:8050731754" className="method-card">
                <div className="icon-wrapper"><Phone size={24} /></div>
                <div>
                  <span className="method-label">CALL NOW</span>
                  <p className="method-value">8050731754</p>
                </div>
              </a>

              <a href="https://wa.me/8050731754" className="method-card">
                <div className="icon-wrapper"><MessageSquare size={24} /></div>
                <div>
                  <span className="method-label">WHATSAPP</span>
                  <p className="method-value">Chat with Support</p>
                </div>
              </a>
            </div>
          </motion.div>

          {/* FORM */}
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="form-card">
            <h3 className="form-header">Appliance Repair Service</h3>

      <form className="contact-form" onSubmit={handleSubmit}>
{/* FULL NAME */}
<div className="floating-group full" >
  <input
    type="text"
    value={name}
    onChange={(e) => setName(e.target.value)}
    placeholder="Full Name"
    required
    style={{ color: "black" }}
  />
  <label>Full Name</label>
</div>

{/* MOBILE + ADDRESS */}
<div className="form-row">
  <div className="floating-group">
    <input
      type="tel"
      value={phone}
      onChange={(e) => setPhone(e.target.value)}
      placeholder="Mobile Number"
      required
       style={{ color: "black" }}
    />
    <label>Mobile Number</label>
  </div>

  <div className="floating-group">
    <input
      type="text"
      value={address}
      onChange={(e) => setAddress(e.target.value)}
      placeholder="Address"
       style={{ color: "black" }}
    />
    <label>Address</label>
  </div>
</div>

{/* EMAIL */}
<div className="floating-group">
  <input
    type="email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    placeholder="Email"
    required
     style={{ color: "black" }}
  />
  <label>Email</label>
</div>
{/* SERVICE */}
<div className="floating-group">
  <select value={service} onChange={(e) => setService(e.target.value)} required>
    <option value="" hidden></option>
    <option>Washing Machine</option>
    <option>Refrigerator</option>
    <option>AC</option>
  </select>
  <label>Service</label>
</div>

{/* BRAND + ISSUE */}
<div className="form-row">
  <div className="floating-group">
    <select value={brand} onChange={(e) => setBrand(e.target.value)} required>
      <option value="" hidden></option>
      <option>LG</option>
      <option>Samsung</option>
    </select>
    <label>Brand</label>
  </div>

  <div className="floating-group">
    <select value={issue} onChange={(e) => setIssue(e.target.value)} required>
      <option value="" hidden></option>
      <option>Not Working</option>
      <option>Noise Issue</option>
    </select>
    <label>Issue Type</label>
  </div>
</div>



{/* DESCRIPTION */}
<div className="floating-group">
  <textarea
    rows="3"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    placeholder="Describe Issue"
  ></textarea>
  <label>Describe Issue</label>
</div>

  <button className="prime-btn">
    <Send size={18} />
    Request Service
  </button> 


    
</form>
          </motion.div>

        </div>
      </div>
    </>
  );
};

export default Contact;

